/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Lob
 */
export interface Lob {
    /**
     * 
     * @type {string}
     * @memberof Lob
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof Lob
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Lob
     */
    description?: string | null;
}

/**
 * Check if a given object implements the Lob interface.
 */
export function instanceOfLob(value: object): value is Lob {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LobFromJSON(json: any): Lob {
    return LobFromJSONTyped(json, false);
}

export function LobFromJSONTyped(json: any, ignoreDiscriminator: boolean): Lob {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function LobToJSON(json: any): Lob {
    return LobToJSONTyped(json, false);
}

export function LobToJSONTyped(value?: Lob | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
    };
}

